<template>
  <ul class="m10 sub-cate vertical-list">
    <li>
      <div class="price-filter container-fluid" v-bind:data_id="$props.filtro.Id">
        <div class="form-group row">
          <div class="col-sm-6 mb-media">
            <input
              type="number"
              class="form-control"
              :id="'slider_range_lb_' + $props.filtro.Id"
              v-bind:min="$props.filtro.Valor_Min"
              v-bind:max="$props.filtro.Valor_Max"
              :disabled="$props.filtro.QtdeProdutos > 0 ? null : 'disabled'"
            />
          </div>
          <div class="col-sm-6">
            <input
              type="number"
              class="form-control"
              :id="'slider_range_ub_' + $props.filtro.Id"
              v-bind:min="$props.filtro.Valor_Min"
              v-bind:max="$props.filtro.Valor_Max"
              :disabled="$props.filtro.QtdeProdutos > 0 ? null : 'disabled'"
            />
          </div>
        </div>
        <div class="form-group row mb-media">
          <div class="col-sm-6">
            <button
              aria-label="Filtrar"
              id="btnFilter"
              class="mb-media filter-submit button-filter btn-sm pull-left form-control"
              :disabled="$props.filtro.QtdeProdutos > 0 ? null : 'disabled'"
              @click.prevent="filtrar($event, $props.filtro, 1)"
            >
              Filtrar
            </button>
          </div>
          <div class="col-sm-6">
            <button
              aria-label="Remover"
              id="btnRemove"
              class="filter-submit button-filter btn-sm pull-right form-control"
              v-show="$props.filtro.FlagFiltro & 4"
              @click.prevent="filtrar($event, $props.filtro, 0)"
            >
              Remover
            </button>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'FilterSlider',
  props: {
    filtro: {
      type: Object,
    },
    callBack: {
      type: Function,
    },
  },
  methods: {
    filtrar: function (ev, sub, applyFlag) {
      if (applyFlag == 1 && $('#slider_range_lb_' + sub.Id).val() == '' && $('#slider_range_ub_' + sub.Id).val() == '') {
        alert('Informe o intervalo que deseja pesquisar.')
        return
      }
      this.$props.callBack(ev, sub, applyFlag)
    },
  },
  mounted() {
    let sub = this.$props.filtro
    $('#slider_range_lb_' + sub.Id).val(sub.Valor_Min)
    $('#slider_range_ub_' + sub.Id).val(sub.Valor_Max)
  },
}
</script>
